import type { ComponentProps } from 'react';
import { OwcFileUploaderItem } from '@one/react';

export type PocFileUploaderItemProps = ComponentProps<typeof OwcFileUploaderItem>;

export const PocFileUploaderItem: React.FC<PocFileUploaderItemProps> = (props) => <OwcFileUploaderItem {...props} />;
